<template>
  <div>
    <v-row class="pa-1">
      <v-col class="d-flex pa-0">
        <v-spacer />
        <v-btn
          @click="dialogComfirmSave = true"
          color="primary"
          :loading="loadingUpdate"
          :disabled="loadingUpdate || this.checkIsEqual"
          class="mr-5"
          >保存</v-btn
        >
        <v-btn @click="$router.go(-1)" color="primary">戻る</v-btn>
      </v-col>
    </v-row>

    <!-- List Question -->
    <v-row>
      <v-layout class="mx-1 mt-5" child-flex>
        <v-data-table
          :headers="headers"
          fixed-header
          :items="listQuestion"
          :items-per-page="50"
          :loading="loadingListQuestion"
          loading-text="読み込み中。。。待ってください。"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="props">
            <draggable :list="listQuestion" tag="tbody">
              <tr v-for="(item, index) in props.items" :key="index">
                <td>{{ item.no }}</td>
                <td>
                  {{
                    probleType.find((e) => e.key == item.type_value)
                      ? probleType.find((e) => e.key == item.type_value).text
                      : ""
                  }}
                </td>
                <td>
                  <span class="pre-wrap">{{ item.lead_sentence }}</span>
                </td>
                <td>
                  <!-- type_value == 'Choices' -->
                  <template
                    v-if="
                      item.type_value == 'Choices' &&
                      typeof item.name[0] != 'string'
                    "
                  >
                    <v-row
                      class="mx-0"
                      v-for="(rowName, idx) in item.name"
                      :key="`preview-${idx}`"
                      :justify="
                        item.name.length == 1 && (!rowName[0] || !rowName[2])
                          ? 'center'
                          : null
                      "
                    >
                      <span
                        class="text--h4 pre-wrap"
                        v-if="rowName[0]"
                        v-html="`${replaceText(rowName[0])}`"
                      />
                      <span
                        class="text--h4 font-weight-bold pre-wrap"
                        v-if="rowName[1] || rowName[1] == ''"
                        v-html="`（&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）`"
                      />
                      <span
                        class="text--h4 pre-wrap"
                        v-if="rowName[1]"
                        v-html="`${replaceText(rowName[1])}`"
                      ></span>
                    </v-row>
                  </template>
                  <!-- type_value == 'Sort' -->
                  <template
                    v-if="
                      item.type_value == 'Sort' &&
                      typeof item.name[0] != 'string'
                    "
                  >
                    <v-row
                      class="mx-0"
                      v-for="(rowName, idx) in item.name"
                      :key="`preview-${idx}`"
                      :justify="
                        item.name.length == 1 && (!rowName[0] || !rowName[2])
                          ? 'center'
                          : null
                      "
                    >
                      <span class="pre-wrap text--h4">
                        <v-row class="d-flex mt-1" no-gutters>
                          {{ replaceText(rowName[0]) }}
                          <template v-if="rowName[1] || rowName[1] == ''">
                            <strong>1</strong>

                            <strong class="mx-1">2</strong>

                            <strong>3</strong>

                            <strong class="mx-1">4</strong>
                          </template>

                          <template v-if="rowName[1] || rowName[1] == ''">
                            {{ replaceText(rowName[1]) }}
                          </template>
                        </v-row>
                      </span>
                    </v-row>
                  </template>
                  <span
                    v-html="nameConvert(item)"
                    v-else-if="
                      typeof item.name[0] == 'string' &&
                      (item.type_value == 'Choices' ||
                        item.type_value == 'Sort')
                    "
                  />
                  <span
                    v-html="nameConvert(item)"
                    v-else-if="
                      item.type_value != 'Choices' && item.type_value != 'Sort'
                    "
                  />
                </td>
              </tr>
            </draggable>
          </template>
          <template v-slot:no-data>データがありません。</template>
        </v-data-table>
      </v-layout>
    </v-row>
    <!-- Dialog confirm save -->
    <v-dialog v-model="dialogComfirmSave" persistent max-width="410">
      <v-card>
        <v-card-title class="headline">確認</v-card-title>
        <v-card-text> 保存します。よろしいですか。</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            @click="handleSave"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
            >OK</v-btn
          >
          <v-btn small @click="dialogComfirmSave = false">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Leave -->
    <v-dialog v-model="dialogComfirmLeave" persistent max-width="410">
      <v-card>
        <v-card-title class="headline">確認</v-card-title>
        <v-card-text
          >並び替えしたデータは保存されません。続行しますか。</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="handleLeave">OK</v-btn>
          <v-btn small @click="dialogComfirmLeave = false">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getListQuestion, updateSortQuestion } from "@/api/Question.api";
import draggable from "vuedraggable";
export default {
  store: ["formGeneral"],
  components: {
    // BasePagination,
    draggable,
  },
  data() {
    return {
      keyword: "",
      listQuestion: [],
      loadingListQuestion: false,
      loadingUpdate: false,
      dialogComfirmSave: false,
      dialogComfirmLeave: false,
      defaultListQuestion: [],
      probleType: [
        { text: "全て", type: "all", key: "" },
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
      ],
      pagination: {
        page: 1,
        pageCount: 0,
        maxResultCount: 5,
      },
      headers: [
        {
          text: "No.",
          align: "start",
          value: "no",
          sortable: false,
        },
        {
          text: this.$i18n.t("PROBLEM_TYPE"),
          value: "type_value",
          sortable: false,
        },
        {
          text: this.$i18n.t("DIRECTIVE"),
          value: "lead_sentence",
          sortable: false,
        },
        {
          text: this.$i18n.t("QUESTION"),
          value: "name",
          width: "30%",
          sortable: false,
        },
      ],
      redirect: null,
      subKey: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    console.log("aaaa=--");
    if (this.checkIsEqual) {
      next();
    } else {
      this.dialogComfirmLeave = true;
      this.redirect = to;
      next(false);
    }
  },
  async created() {
    this.setSubKey();
    await this.handleGetListQuestion();
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.name !== "Sort List General OF Section") {
      this.probleType.push(
        { text: "読解：4択", type: "read", key: "Comprehension" },
        { text: "読解：複数選択", type: "read", key: "MultiRead" }
      );
    }
  },
  watch: {
    $route: async function () {
      this.setSubKey();
      await this.handleGetListQuestion();
    },
  },
  computed: {
    validateCreateButton() {
      const { subKey, defaultListQuestion } = this;
      if (subKey == "season" && defaultListQuestion.length == 50) {
        return true;
      } else if (subKey == "chapter" && defaultListQuestion.length == 30) {
        return true;
      } else if (subKey == "section" && defaultListQuestion.length == 10) {
        return true;
      }
      return false;
    },
    checkIsEqual() {
      const { listQuestion, defaultListQuestion, _ } = this;
      return _.isEqual(listQuestion, defaultListQuestion);
    },
  },

  methods: {
    async handleGetListQuestion() {
      const { subKey } = this;
      console.log("this.$route.params: ", this.$route.params);
      let params = {
        id: this.$route.params[subKey],
      };
      this.loadingListQuestion = true;
      let response = await getListQuestion(params).catch(this.$toast.error);
      if (!response) return (this.loadingListQuestion = false);
      this.listQuestion = [...response.result];
      this.defaultListQuestion = [...response.result];
      this.pagination.pageCount = response.totalCount;
      this.loadingListQuestion = false;
    },
    setSubKey() {
      if (this.$route.name == "Sort List General OF Season") {
        this.subKey = "season";
      } else if (this.$route.name == "Sort List General OF Chapter") {
        this.subKey = "chapter";
      } else if (this.$route.name == "Sort List General OF Section") {
        this.subKey = "section";
      }
    },
    handleEditORViewDetailItem(item, key) {
      let rearecte = this.paramsRearecte(key);
      rearecte.params.id = item.Id;
      if (key !== "Create") {
        rearecte.query = { no: item.no, ...this.$route.query };
      } else {
        let query = { ...this.$route.query, ...rearecte };
        rearecte.query = query;
      }
      this.$router.push(rearecte);
    },
    replaceText(name) {
      return name
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    handleLeave() {
      const { redirect } = this;
      if (redirect && redirect.name) {
        this.dialogComfirmLeave = false;
        this.listQuestion = [...this.defaultListQuestion];
        this.$router.push(redirect).catch(() => console.log());
      }
    },
    nameConvert(item) {
      const { type_value } = item;
      if (type_value == "Choices") {
        return `${this.replaceText(
          item.name[0]
        )}（&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;） ${this.replaceText(
          item.name[1]
        )}`;
      }
      if (type_value == "Sort") {
        return `${this.replaceText(
          item.name[0]
        )} <strong>1</strong> <strong>2</strong> <strong>3</strong> <strong>4</strong> ${this.replaceText(
          item.name[1]
        )}`;
      }
      if (type_value == "Conjugation") {
        let unline = "";
        item.list_answer.answer[0].forEach(() => {
          unline += " __ ";
        });
        return `${this.replaceText(
          item.list_answer.sentence_answer[0]
        )} ${unline} ${this.replaceText(item.list_answer.sentence_answer[1])}`;
      }
      if (type_value == "Kanji") {
        return `${this.replaceText(item.name[0][0])} <u>${this.replaceText(
          item.name[0][1]
        )}</u> ${this.replaceText(item.name[0][2])}`;
      }
      if (item.name[0] && item.name[0][0]) {
        return this.replaceText(item.name[0][0]);
      } else if (item.name[0]) {
        return item.name[0][0];
      } else {
        return "";
      }
    },
    paramsRearecte(key) {
      var paramsRearecte = "";
      const { query } = this.$route;
      if (this.$route.name == "List General OF Season") {
        paramsRearecte = {
          name: `${key} General OF Season`,
          params: { season: this.$route.params.season },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : query,
        };
      } else if (this.$route.name == "List General OF Chapter") {
        paramsRearecte = {
          name: `${key} General OF Chapter`,
          params: { chapter: this.$route.params.chapter },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : query,
        };
      } else if (this.$route.name == "List General OF Section") {
        paramsRearecte = {
          name: `${key} General OF Section`,
          params: { section: this.$route.params.section },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : query,
        };
      }
      return paramsRearecte;
    },
    async handleSave() {
      const { listQuestion, subKey, _ } = this;
      let data = [];
      this.dialogComfirmSave = true;
      this.loadingUpdate = true;
      if (!this.checkIsEqual) {
        _.forEach(listQuestion, function (o, idx) {
          data.push({
            id: o.Id,
            no: idx,
          });
        });
        let params = {
          id: this.$route.params[subKey],
          data,
        };
        await updateSortQuestion(params).then(async () => {
          this.dialogComfirmSave = false;
          this.loadingUpdate = false;
          this.listQuestion = [...this.defaultListQuestion];
          this.$router.go(-1);
        });
      }
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
td {
  cursor: move;
}
</style>